export function r2StoragePrefix(): string {
  const env = process.env.NEXT_PUBLIC_APP_ENV ?? "localhost";
  return env === "production" ? "" : `${env}/`;
}

export async function uploadToR2(
  pathname: string,
  blob: Blob,
  contentType: string
): Promise<string> {
  const tokenRes = await fetch("/api/recipes/upload-url", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ pathname, contentType, size: blob.size }),
  });

  if (!tokenRes.ok) {
    const text = await tokenRes.text();
    throw new Error(text || `Upload token request failed: ${tokenRes.status}`);
  }

  const { uploadUrl, publicUrl } = (await tokenRes.json()) as {
    uploadUrl: string;
    publicUrl: string;
  };

  const putRes = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": contentType },
    body: blob,
  });

  if (!putRes.ok) {
    throw new Error(`R2 upload failed: ${putRes.status}`);
  }

  return publicUrl;
}
